module.exports = __webpack_public_path__ + "img/2.f0dff9f7.jpg";